// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__2KMFD","short":"styles_short__NTfD9","medium":"styles_medium__zbEQ7","long":"styles_long__fCFD3","max":"styles_max__3cocI"};